// extracted by mini-css-extract-plugin
export default {"movieCard":"MovieCard_movieCard__vDWCj","movieImage":"MovieCard_movieImage__YcyJ4"};